import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import UpcomingProject from "./components/UpcomingProject";
import AboutUs from "./components/AboutUs";
import Founders from "./components/Founders";
import Inquiries from "./components/Inquiries";
import Footer from "./components/Footer";
import ShapeOfElsewhere from "./pages/ShapeOfElsewhere";
import ThroughTheLookingGlass from "./pages/ThroughTheLookingGlass";
import Projects from "./pages/Projects";
import Seo from "./components/Seo";

// When the homepage receives /#section in URL, scroll to that section after mount.
function HashScroller() {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // small delay so DOM is ready
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      return () => clearTimeout(t);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);
  return null;
}

const Home = () => (
  <main data-testid="home-page" className="bg-white">
    <Seo
      title="NYG Projects — Where Art Becomes Encounter"
      description="NYG Projects is an art collective staging intimate pop-up exhibitions shaped by place, connection and experience across London, Istanbul and Athens."
      image="/share/og-home.jpg"
      imageAlt="NYG Projects — Where Art Becomes Encounter"
      path="/"
    />
    <HashScroller />
    <Nav variant="light" />
    <Hero />
    <UpcomingProject />
    <AboutUs />
    <Founders />
    <Inquiries />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/shape-of-elsewhere" element={<ShapeOfElsewhere />} />
          <Route path="/projects/through-the-looking-glass" element={<ThroughTheLookingGlass />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
